import { render, staticRenderFns } from "./SimulationSolAgoraStep2.vue?vue&type=template&id=680b5cc2&scoped=true&"
import script from "./SimulationSolAgoraStep2.vue?vue&type=script&lang=js&"
export * from "./SimulationSolAgoraStep2.vue?vue&type=script&lang=js&"
import style0 from "./SimulationSolAgoraStep2.vue?vue&type=style&index=0&id=680b5cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b5cc2",
  null
  
)

export default component.exports